import { render } from "./Insight.vue?vue&type=template&id=8f1f388e&scoped=true"
import script from "./Insight.vue?vue&type=script&lang=js"
export * from "./Insight.vue?vue&type=script&lang=js"

import "./Insight.vue?vue&type=style&index=0&id=8f1f388e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8f1f388e"

export default script